
import DocumentCode from "../../../assets/outline/DocumentCode.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function DocumentCodeIcon({ className, dataTestid = "DocumentCodeIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <DocumentCode data-testid={dataTestid} className={classes} {...rest} />
  );
}
